export default __webpack_public_path__ + "static/media/image.begood-solutions.09948228.png";